import { FindokItem } from '@/models/RSSFindokModels'

class RSSFindokService {

  private mockResponseString = '<?xml version="1.0" encoding="UTF-8"?><rss version="2.0"><channel><title>personalisierte Findok Neuzugänge</title><link>https://findok.portal.at/findokintra</link><description>RSS für die die persönlichen BFG-Neuzugänge</description><language>de-AT</language><description>Bundesministerium für Finanzen</description><pubDate>Fr, 27 Sep 2024 13:15:08 +0100</pubDate><item><title>Interner Organisationserlass zu Prüfungsmaßnahmen aufgrund des COFAG-NoAG</title><description>Interner Organisationserlass zu Prüfungsmaßnahmen aufgrund des COFAG-NoAG - Erlass, 2024-0.687.191 vom 23.09.2024</description><link>https://findok.portal.at/findokintra?dokumentId=733edabf-f602-4904-87c2-164b043c182a&amp;neuzugang=true</link><guid>733edabf-f602-4904-87c2-164b043c182a</guid><pubDate>Di, 24 Sep 2024 14:01:09 +0100</pubDate></item><item><title>Neuigkeiten aus der Direktbearbeitung vom 23.09.2024 (Automatik-Vorauszahlungen 2025)</title><description>Neuigkeiten aus der Direktbearbeitung vom 23.09.2024 (Automatik-Vorauszahlungen 2025) - Info, 2024-0.633.746 vom 23.09.2024</description><link>https://findok.portal.at/findokintra?dokumentId=8dc1154d-ae6a-4ab0-8193-5907944f3151&amp;neuzugang=true</link><guid>8dc1154d-ae6a-4ab0-8193-5907944f3151</guid><pubDate>Di, 24 Sep 2024 09:05:42 +0100</pubDate></item><item><title>Vorgehensweise im Zusammenhang mit den aktuellen Hochwasserkatastrophen 09/2024</title><description>Vorgehensweise im Zusammenhang mit den aktuellen Hochwasserkatastrophen 09/2024 - Erlass, 2024-0.672.223 vom 18.09.2024</description><link>https://findok.portal.at/findokintra?dokumentId=bc9a60ad-d2c7-4cac-89c1-c7588315d80f&amp;neuzugang=true</link><guid>bc9a60ad-d2c7-4cac-89c1-c7588315d80f</guid><pubDate>Do, 19 Sep 2024 09:05:45 +0100</pubDate></item></channel></rss>'
  private mockResponseString2 = '<?xml version="1.0" encoding="UTF-8"?><rss version="2.0"><channel><title>personalisierte Findok Neuzugänge</title><link>https://findok.portal.at/findokintra</link><description>RSS für die die persönlichen BFG-Neuzugänge</description><language>de-AT</language><description>Bundesministerium für Finanzen</description><pubDate>Fr, 11 Okt 2024 12:46:39 +0100</pubDate><item><title>Logfile-Auswertungen</title><description>Logfile-Auswertungen - Erlass, 2024-0.610.280 vom 01.10.2024</description><link>https://findok.portal.at/findokintra?dokumentId=0c984529-4e32-4bcd-92a3-69fdcf4ee626&amp;neuzugang=true</link><guid>0c984529-4e32-4bcd-92a3-69fdcf4ee626</guid><pubDate>Di, 01 Okt 2024 14:09:26 +0100</pubDate></item><item><title>Dienstzeitregelung des Finanzressorts - Wiederverlautbarung</title><description>Dienstzeitregelung des Finanzressorts - Wiederverlautbarung - Erlass, 2024-0.671.534 vom 01.10.2024</description><link>https://findok.portal.at/findokintra?dokumentId=10f0a28a-b5e9-428f-bad2-1642765ab6ab&amp;neuzugang=true</link><guid>10f0a28a-b5e9-428f-bad2-1642765ab6ab</guid><pubDate>Di, 01 Okt 2024 13:55:55 +0100</pubDate></item><item><title>Handbuch für das Prozessmanagement in der Finanzverwaltung</title><description>Handbuch für das Prozessmanagement in der Finanzverwaltung - Info, 2024-0.695.987 vom 30.09.2024</description><link>https://findok.portal.at/findokintra?dokumentId=41d0b923-d429-4e38-ad04-85632123ee57&amp;neuzugang=true</link><guid>41d0b923-d429-4e38-ad04-85632123ee57</guid><pubDate>Di, 01 Okt 2024 07:26:01 +0100</pubDate></item></channel></rss>'
  private mockResponseString3 = '<?xml version="1.0" encoding="UTF-8"?><rss version="2.0"><channel><title>personalisierte Findok Neuzugänge</title><link>https://t-findok-a.portal.at/findokintra</link><description>RSS für die die persönlichen BFG-Neuzugänge</description><language>de-AT</language><description>Bundesministerium für Finanzen</description><pubDate>2024-10-17T14:19:16+0200</pubDate><item><title>BRZ999999/Abferti-RL-Test-1</title><description>BRZ999999/Abferti-RL-Test-1 - Richtlinie, BRZ999999/Abferti-RL-Test-1 vom 11.10.2024</description><link>https://t-findok-a.portal.at/findokintra?dokumentId=552e63aa-0752-47cd-b9f9-4c991048cd71&amp;neuzugang=true</link><guid>552e63aa-0752-47cd-b9f9-4c991048cd71</guid><pubDate>2024-10-11T16:25:09+0200</pubDate></item><item><title>BRZ999999/Abferti-Test-1</title><description>BRZ999999/Abferti-Test-1 - Erlass, BRZ999999/Abferti-Test-1 vom 11.10.2024</description><link>https://t-findok-a.portal.at/findokintra?dokumentId=4c9709bc-ad9d-48f3-b540-7fc8bb0f0c23&amp;neuzugang=true</link><guid>4c9709bc-ad9d-48f3-b540-7fc8bb0f0c23</guid><pubDate>2024-10-11T16:16:48+0200</pubDate></item><item><title>Titel 240903</title><description>Titel 240903 - Erlass, BRZ999999/240903 vom 24.09.2024</description><link>https://t-findok-a.portal.at/findokintra?dokumentId=54fcf728-0424-4cff-a50b-fb873b6f149d&amp;neuzugang=true</link><guid>54fcf728-0424-4cff-a50b-fb873b6f149d</guid><pubDate>2024-09-24T10:29:58+0200</pubDate></item></channel></rss>'


  public async getFindokItems(findokUrl: string, mockResults: string): Promise<FindokItem[]> {
    try {
      let data = '';

      if (mockResults === 'true') {
        //console.log('Mocking results');
        await new Promise(f => setTimeout(f, 1000));
        data = this.mockResponseString3;
      } else {
        //console.log('Fetching URL:', findokUrl);
        const response = await fetch(findokUrl,{
          credentials: 'include'
        });
        data = await response.text();
      }
      //console.log('Data fetched:', data);

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data, "application/xml");
      //console.log('Parsed XML:', xmlDoc);

      const items = xmlDoc.querySelectorAll("item");
      const findokItems = new Array<FindokItem>();

      items.forEach(item => {
        const findokItem = <FindokItem>{};
        const title = item.querySelector("title");
        if (title && title.textContent) {
          findokItem.title = title.textContent;
        } else {
          // different default title or don't add item at all?
          findokItem.title = '';
        }
        const description = item.querySelector("description");
        if (description && description.textContent) {
          findokItem.description = description.textContent;
        }
        const link = item.querySelector("link");
        if (link && link.textContent) {
          findokItem.link = link.textContent;
        }
        const guid = item.querySelector("guid");
        if (guid && guid.textContent) {
          findokItem.guid = guid.textContent;
        }
        const pubDate = item.querySelector("pubDate");
        if (pubDate && pubDate.textContent) {
          try {
            const pubDateDate = Date.parse(convertGermanDateString(pubDate.textContent));
            if (!isNaN(pubDateDate)) {
              findokItem.pubDate = new Date(pubDateDate);
            } else {
              //console.error(pubDate && pubDate.textContent + ' not the expected date format!')
            }
          } catch (error) {
            //console.error('date parse error:', error);
          }
        }

        findokItems.push(findokItem);
      });

      return findokItems;

    } catch (error) {
      //console.error('Error fetching the RSS feed:', error);
      throw new Error("Findok items could not be loaded")
    }
  }
}

function convertGermanDateString(germanDateStr: string) {
      const monthsMap = new Map<string, string>([
          ["Jan", "Jan"],
          ["Jän", "Jan"],
          ["Feb", "Feb"],
          ["Mär", "Mar"],
          ["Apr", "Apr"],
          ["Mai", "May"],
          ["Jun", "Jun"],
          ["Jul", "Jul"],
          ["Aug", "Aug"],
          ["Sep", "Sep"],
          ["Okt", "Oct"],
          ["Nov", "Nov"],
          ["Dez", "Dec"]
      ]);

      const englishDateStr = germanDateStr.replace(
          /\b(Jan|Jän|Feb|Mär|Apr|Mai|Jun|Jul|Aug|Sep|Okt|Nov|Dez)\b/,
          (match) => monthsMap.get(match) || match
      );

      return englishDateStr;
  }

const rssFindokService = new RSSFindokService()
export default rssFindokService
